require('dotenv').config();

/* eslint-disable max-len */

export const port = process.env.PORT || 3000;
export const host = process.env.WEBSITE_HOSTNAME || `localhost:${port}`;
export const url = process.env.WEBSITE_URL || `http://localhost:${port}`;
export const sitename = 'pleXpad';
export const isLive = /^https?:\/\/(www\.)plexpad\./i.test(url);
export const adminEmail = process.env.ADMIN_EMAIL || 'info@plexpad.com';
export const customerSupportEmail = process.env.CS_EMAIL || 'info@plexpad.com';
export const adminMobileNumbers = [
  {
    name: 'Luke',
    number: '+447869118790'
  },
  {
    name: 'Lech',
    number: '+447904698294'
  }
];

export const searchResultsDefaultMaxDistanceKM = 3;
export const searchResultsPerPage = 20;

export const adminItemsPerPage = 100;

export const blogPostsPerPage = 10;

// Max File upload size in MB
export const maxUploadSize = 20;

// Default locale is the first one
export const locales = ['en-GB', 'de'/*, 'en-US', 'es', 'it-IT', 'fr-FR', 'pt-PT', 'ar'*/];

export const databaseUrl = process.env.DATABASE_URL;

// Listing Photos Upload Directory
export const fileuploadDir = process.env.FILEUPLOAD_DIR || './images/upload/';

// Blog Photos Upload Directory
export const bloguploadDir = process.env.BLOGUPLOAD_DIR || './images/blog/';

// Logo upload directory
export const logouploadDir = process.env.LOGOUPLOAD_DIR || './images/logo/';

// Home page Banner upload directory
export const banneruploadDir = process.env.BANNER_UPLOAD_DIR || './images/banner/';

// User Profile Photos Upload Directory
export const profilePhotouploadDir = process.env.PROFILE_PHOTO_UPLOAD_DIR || './images/avatar/';

//Document Upload
export const documentuploadDir = process.env.FILEUPLOAD_DIR || './images/document/';

// Location upload directory
export const locationuploadDir = process.env.LOGOUPLOAD_DIR || './images/popularLocation/';

// Static block image upload directory
export const homebanneruploadDir = process.env.HOME_BANNER_UPLOAD_DIR || './images/home/';

// Amenities upload directory
export const amenitiesUploadDir = process.env.AMENITIES_UPLOAD_DIR || './images/amenities/';

export const analytics = {
  
  facebook: {
    pixelId: process.env.FACEBOOK_PIXEL_ID || '234837399422994',
  },

  // https://analytics.google.com/
  google: {
    trackingId: process.env.GOOGLE_TRACKING_ID || '',
  },

};

export const googleMapAPI = process.env.GOOGLE_MAP_API || 'AIzaSyAWijGQPPhpZR_CAIkggRoG7PZ3vxZnHP0';
export const googleMapServerAPI = process.env.GOOGLE_MAP_SERVER_API || 'AIzaSyAWijGQPPhpZR_CAIkggRoG7PZ3vxZnHP0';

export const serverKey = process.env.PUSH_NOTIFICATION_SERVER_KEY || 'AAAASKPM1B4:APA91bGhirQCEIKyBwY-E535f5fNTUjnnaxZJmcbkv6plZvL8T_UhQepbIEmVyKeFRCrgunn8chZMR2U-qqCU6DfQWIkGYBHMb7OCsd9opTT8xvukqb9hG9ygEs8X02SLUjFFUAU7-mC';
export const deepLinkBundleId = process.env.DEEP_LINK_BUNDLE_ID || '<iOS DEEP LINK BUNDLE ID Ex: 1234546.com.RentALL.app>';

export const payment = {

  paypal: {
    email: process.env.PAYPAL_APP_EMAIL || '',
    clientId: process.env.PAYPAL_APP_CLIENT_ID || '',
    secret: process.env.PAYPAL_APP_SECRET || '',
    host: process.env.PAYPAL_HOST || 'api.sandbox.paypal.com',
    hostMode: process.env.PAYPAL_MODE || 'sandbox', //sandbox or live
    returnURL: `${url}${process.env.PAYPAL_RETURN_URL || '/success'}`,
    cancelURL: `${url}${process.env.PAYPAL_CANCEL_URL || '/cancel'}`,
    redirectURL: {
      success: `${url}${process.env.PAYPAL_SUCCESS_REDIRECT_URL || '/users/trips/itinerary'}`,
      cancel: `${url}${process.env.PAYPAL_CANCEL_URL || '/cancel'}`
    },
  },

  stripe: {
    secretKey: process.env.STRIPE_SECRET || 'sk_test_51JtdlRKVpd6eFBrPjBWxhBxHI0J2GgVaNtg4peJfEk76uKu3uoP3Ke06Ted94shnaHeNVPnX8NSOxoUzXVUEVLNY00i2HMXJqt',
    publishableKey: process.env.STRIPE_PUBLIC || 'pk_test_51JtdlRKVpd6eFBrPoJC90olAy24uDmi3HfCjYUN51qOWz1qDy2zzQ6aS8rm4KwHgBbkNo0ZctdiFkVJHQG8uqmcc00fBkzuBtx',
    endpointSecret: process.env.STRIPE_ENDPOINT_SECRET || 'whsec_v5Mu1YJVszlqKrhyiRyz9EArnW3jxpaf'
  }

};

// site key for google recaptcha
export const googleCaptcha = {
  sitekey: '6LdP7yogAAAAABOy1i3tsc-9dchKQx-KM44IjFsX',
};

// SMS verification
export const sms = {
  twilio: {
    accountSid: process.env.TWILIO_ACCOUNTSID || 'AC7697352a1ac71de66f6e7b29c64eafdd',
    authToken: process.env.TWILIO_AUTHTOKEN || '8cc0e4fc036eade8d9300898b20ffbe7',
    phoneNumber: process.env.TWILIO_PHONENUMBER || '+447360277419'
  }
};

// Email Settings
export const emailConfig = {
  host: process.env.SMTP_HOST || 'smtp.sendgrid.net',
  port: process.env.SMTP_PORT || 587,
  email: process.env.SMTP_LOGIN_EMAIL || 'apikey',
  sender: process.env.SMTP_FROM_NAME || 'pleXpad',
  senderEmail: process.env.SMTP_SENDER_EMAIL || 'info@plexpad.com',
  password: process.env.SMTP_LOGIN_PASSWORD || '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',
  secure: process.env.SMTP_SECURE || true,
  tls: process.env.SMTP_TLS || true,
};

export const auth = {

  jwt: { secret: process.env.JWT_SECRET || '5j7jhAiZUlgVhOd5J96n3r3C0vy6TeoETXDPl4vxQ4KsxN5b3GCo93TxJRkhbnEb' },

  redirectURL: {
    login: process.env.LOGIN_URL || '/',
    verification: process.env.LOGIN_URL || '/user/verification',
    userbanned: process.env.USER_BANNED_URL || '/userbanned',
    returnURLDeletedUser: process.env.DELETE_USER_URL || '/userbanned'
  },

  // https://developers.facebook.com/
  facebook: {
    id: process.env.FACEBOOK_APP_ID || '501226488397876',
    secret: process.env.FACEBOOK_APP_SECRET || 'b84d74a968098bd135a6f5967ea94903',
    returnURL: process.env.FACEBOOK_CLIENT_URL || `${url}/login/facebook/return`,
  },

  // https://cloud.google.com/console/project
  google: {
    id: process.env.GOOGLE_CLIENT_ID || '311985755166-n5rt491opou0gq52a14vgo2gu8kp6ee0.apps.googleusercontent.com',
    secret: process.env.GOOGLE_CLIENT_SECRET || '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',
    returnURL: process.env.GOOGLE_CLIENT_URL || `${url}/login/google/return`,
  }
};

export const dateFormat = "DD/MM/YYYY";



// WEBPACK FOOTER //
// src/config.js